export const TOGGLE_FAVOURITE_LEAGUE = 'TOGGLE_FAVOURITE_LEAGUE';
export const TOGGLE_FAVOURITE_MATCH = 'TOGGLE_FAVOURITE_MATCH';
export const TOGGLE_FAVOURITE_SPORT = 'TOGGLE_FAVOURITE_SPORT';



// WEBPACK FOOTER //
// ./js/actions/Favourites.js